import { render, staticRenderFns } from "./GuestbookForm.vue?vue&type=template&id=9c0f691a&scoped=true&"
import script from "./GuestbookForm.vue?vue&type=script&lang=js&"
export * from "./GuestbookForm.vue?vue&type=script&lang=js&"
import style0 from "./GuestbookForm.vue?vue&type=style&index=0&id=9c0f691a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0f691a",
  null
  
)

export default component.exports